

import React from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect, Link} from 'react-router-dom';

import firebase from './adapters/firebase';

import { GlobalProvider } from './contexts/GlobalContext';

import Landing from './pages/Landing';
import Register from './pages/Register';
import Login from './pages/Login';
import Home from './pages/Home';

function App() {
  return (


    <GlobalProvider>

      <Router>

        {/* <nav>
          <ul>
            <li>
              <Link to='/register'>Register</Link>
            </li>

            <li>
              <Link to='/login'>Login</Link>
            </li>
          </ul>
        </nav> */}

        <Switch>
          <Route path='/register'>
            <Register />
          </Route>

          <Route path='/login'>
            <Login />
          </Route>

          <Route path='/home'>
            <Home />
          </Route>
        </Switch>

        <Route exact path="/">
          <Redirect to="/login" />
      </Route>
      </Router>

      </GlobalProvider>


  );
}

export default App;
